import { AuthUser } from './auth-user';
import { Right } from './right';
import { Guardian } from './guardian';

/**
 * Classe que representa os Usuários do sistema
 */
export class User {
    /** ID da entidade no Firebase  */
    uuid: string;

    /** Email */
    email: string;

    // /** Direitos <Array:Right> */
    // rights: Array<Right>;

    /** Direito */
    right: Right;

    /** Authentication UUID */
    auth_uuid: string;

    /**  */
    auth_user: AuthUser;

    guardian?: Guardian;

    /**
     * Instanciar um novo Usuário
     * @param init - JSON que represente parcialmente as propriedades da classe
     */
    public constructor(init?: Partial<User>) {
        Object.assign(this, init);
    }

    /**
     *
     */
    toFirebase(): object {
        return {
            email: this.email,
            right: this.right ? this.right.toFirebase() : null,
            guardian: this.guardian ? this.guardian.toFirebase() : null,
        };
    }
}
